import { put, call, takeLatest, select } from 'redux-saga/effects';

import { formatError } from '../../../libs';
import customerAPI from '../../api/customer';
import { Creators as AppCreators } from '../../reducers/app';
import { Types, Creators } from '../../reducers/customer';
import getState from '../../utils/getState';

function* rescuePasswordRequest({ mail }) {
  try {
    const { app } = yield select(getState);
    const siteId = app.getIn(['config', 'siteId']);

    const data = yield call(customerAPI.rescuePassword, mail, siteId);

    data.message = `As instruções para alteração de senha foram enviadas no email ${mail}.`;

    yield put(Creators.rescuePasswordSuccess(data));
  } catch (error) {
    const formatted = formatError(error);
    yield put(Creators.rescuePasswordFailed(formatted));
    yield put(AppCreators.feedbackRequest({ open: true, message: formatted.message }));
  }
}

export default function* watch() {
  yield takeLatest(Types.RESCUE_PASSWORD_REQUEST, rescuePasswordRequest);
}
